import axios from "axios";
import { Store } from "redux";
import { context } from "../context";
import store from "../store";
import { ERROR_UPDATE } from "../store/slices";
import { AuthenticationInstance } from "./authenticationClass";

//const BASEURL = 'https://api.dev.canna42.com';

class DatabaseClass {
  private store: Store;
  private BASEURL: string | undefined;

  constructor(store: Store) {
    this.store = store;
    this.BASEURL = context.apiEndpoint;
  }

  public getJWTToken = async () => {
    try {
      const res = await AuthenticationInstance.getCurrentSession();

      if (!res?.token) return;
      return res.token;
    } catch (error) {
      console.error("Error getting token:", error);
      throw error;
    }
  };

  public getRecord = async ({
    data,
    endpoint,
    config = {},
    headers = {},
    isPublic = false,
  }: {
    data?: any;
    endpoint: string;
    config?: any;
    headers?: any;
    isPublic?: boolean;
  }) => {
    try {
      const jwtToken = await this.getJWTToken();

      if (!jwtToken && !isPublic) return;

      const res = await axios.get(`${this.BASEURL}/${endpoint}`, {
        ...config,
        headers: {
          authorization: jwtToken,
          ...headers,
        },
      });

      return res.data;
    } catch (error) {
      console.error("Error in query:", error);
      throw error;
    }
  };

  public createRecord = async ({
    data,
    endpoint,
    config,
    headers = {},
    params = {},
    isPublic = false,
  }: {
    data: any;
    endpoint: string;
    config?: any;
    headers?: any;
    params?: any;
    isPublic?: boolean;
  }) => {
    try {
      const jwtToken = await this.getJWTToken();

      if (!jwtToken && !isPublic) return;

      const res = await axios.post(`${this.BASEURL}/${endpoint}`, data, {
        ...config,
        headers: {
          Authorization: jwtToken,
          ...headers,
        },
        params,
      });

      return res.data;
    } catch (error: any) {
      console.error("Error in query:", error);
      await this.store.dispatch(
        ERROR_UPDATE({
          data: {
            error: true,
            message: error.response.data.error,
            isLoading: false,
            success: false,
          },
        }),
      );
      throw error;
    }
  };

  public updateRecord = async ({
    data,
    endpoint,
    config = {},
    headers = {},
  }: {
    data?: any;
    endpoint: string;
    config?: any;
    headers?: any;
  }) => {
    try {
      const jwtToken = await this.getJWTToken();

      if (!jwtToken) return;

      console.log("calling update record with the folloing data and endpoint:", data, endpoint);

      const res = await axios.put(`${this.BASEURL}/${endpoint}`, data, {
        ...config,
        headers: {
          Authorization: jwtToken,
          ...headers,
        },
      });

      return res.data;
    } catch (error) {
      console.error("Error in query:", error);
      throw error;
    }
  };

  public deleteRecord = async ({ endpoint, config, headers }: { endpoint: string; config?: any; headers?: any }) => {
    try {
      const jwtToken = await this.getJWTToken();

      if (!jwtToken) return;

      const res = await axios.delete(`${this.BASEURL}/${endpoint}`, {
        ...config,
        headers: {
          Authorization: jwtToken,
          ...headers,
        },
      });

      return res.data;
    } catch (error) {
      console.error("Error in query:", error);
      throw error;
    }
  };
}

const DatabaseInstance = new DatabaseClass(store);

export { DatabaseInstance };
